import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import { TRANSCRIPT_ROUTES } from "./modules/constants";
import {
  Schools,
  Students,
  Templates,
  TemplateDetails,
  StudentDetails,
  SchoolDetails,
  YearGroups,
  YearGroupDetails,
} from "./routes";

const routesWithSideNav = store => ({
  path: "",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-v3-sidenav-outlet" */ "./components/SideNavigationOutlet"
    ).then(m => m.default)
  ),
  indexRoute: {
    component: null,
  },
  childRoutes: [
    Schools(store),
    Students(store),
    Templates(store),
    YearGroups(store),
  ],
});

export default store => ({
  path: TRANSCRIPT_ROUTES.BASE_ROUTE,
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "transcripts-v3" */ "./components"),
      import(
        /* webpackChunkName: "transcripts-v3" */ "./modules/TranscriptsV3Module"
      ),
    ]).then(([importedModule0, importedModule1]) => {
      const component = importedModule0.default;
      const reducer = importedModule1.default;
      injectReducer(store, {
        key: "transcriptV3",
        reducer,
      });
      return component;
    })
  ),
  childRoutes: [
    routesWithSideNav(store),
    TemplateDetails(store),
    StudentDetails(store),
    SchoolDetails(store),
    YearGroupDetails(store),
  ],
});
